import {UserRoleLevel} from '../../constants/dataEnum';

export const getSessionUser = (state) => state.sessionState.user;

export const selectSessionUserId = (state) => state.sessionState.user.userId;
export const selectSessionUserUsername = (state) => state.sessionState.user.username;

export const getSessionId = (state) => state.sessionState.sessionId;

export const getIsOperator = (state) => {
  const userRole = state.sessionState?.user?.userRole || 0;
  return Number(userRole) - 1 === UserRoleLevel.OPERATOR;
};
